<template>
  <div>
    <v-container fluid>
      <v-row align="center">
        <v-col cols="4">
          <v-text-field
              :value="brandComponentSearchTerm"
              label="Search in MPN, Description, Information and Specification"
              outlined
              dense
              clearable
              @input="onUpdateBrandComponentSearchTerm"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-select
              :value="brandComponentCategorySearchId"
              :items="getCategories"
              outlined
              dense
              clearable
              label="Component category"
              @change="onUpdateBrandComponentCategory"
          ></v-select>
        </v-col>
        <v-col cols="4" class="mt-n7">
          <div class="text-center">
            <v-dialog
                v-model="dialog"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="brandComponentCategorySearchId == null"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                  Advanced search by parameters
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  Advanced search by parameters
                </v-card-title>
                  <v-card-text>
                    <v-data-table
                        :headers="columns"
                        :items="getBrandComponentParameters"
                        item-key="name"
                        class="elevation-1"
                        dense
                        multi-sort
                    >
                      <template v-slot:item.value="props">
                             <span v-if="props.item.parameter_type === 'list'">
                                  <v-select
                                      class="mt-3 mb-n3"
                                      v-model="props.item.value"
                                      :items="props.item.choice_list"
                                      dense
                                      outlined
                                      multiple
                                      chips
                                      clearable
                                      label="choice"
                                  ></v-select>
                                </span>
                        <span v-else class="parameter-edit">
                                <v-text-field
                                    class="mt-3 mb-n3"
                                    v-model="props.item.value"
                                    label="edit"
                                    dense
                                    outlined
                                    clearable
                                ></v-text-field>
                             </span>
                      </template>

                    </v-data-table>
                  </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                      color="primary"
                      text
                      @click="onSearch"
                  >
                    Search
                  </v-btn>
                </v-card-actions>
              </v-card>

            </v-dialog>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from "vuex";
import 'vue-good-table/dist/vue-good-table.css'
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'getBrandComponentSearchField',
  mutationType: 'updateBrandComponentSearchField',
});

export default {
  name: 'BrandComponentSearch',
  components: {},
  computed: {
    ...mapGetters(['getCategories', 'getComponentSpec', 'getBrandComponentParameters']),
    ...mapFields(['brandComponentSearchTerm', 'brandComponentCategorySearchId'])
  },
  methods: {
    ...mapActions(['fetchComponentList', 'fetchBrandComponentCategoryParameters', 'fetchCategoryList']),
    ...mapMutations(['updateBrandComponentCategorySearchId', 'updateBrandComponentSearchTerm']),
    onUpdateBrandComponentSearchTerm(brandComponentSearchTerm) {
      this.$store.commit('updateBrandComponentSearchTerm', brandComponentSearchTerm)
      this.fetchComponentList();
    },
    onUpdateBrandComponentCategory(brandComponentCategorySearchId) {
      this.$store.commit('updateBrandComponentCategorySearchId', brandComponentCategorySearchId)
      this.fetchComponentList();
      this.fetchBrandComponentCategoryParameters();
    },
    onSearch() {
      this.fetchComponentList();
      this.dialog = false
    },
  },
  async mounted() {
  },
  data() {
    return {
      dialog: false,
      columns: [
        {
          text: 'Section',
          value: 'section',
        },
        {
          text: 'Parameter',
          value: 'parameter',
        },
        {
          text: 'Parameter name',
          value: 'parameter_name',
        },
        {
          text: 'Match',
          value: 'match',
        },
        {
          text: 'Value',
          value: 'value',
        },
        {
          text: 'Unit',
          value: 'unit',
        },
      ],
    }
  },
};
</script>

<style scoped lang="scss">
.brand-component-search {
  //max-height: 600px;
}

//.parameter-edit {
//  margin-top: 30px;
//}
</style>